import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { user } from '../model/user.fragments';
import { UserOutput } from '../model/user.output';

export interface AssociateCoachWithCoacheeInput {
	readonly coacheeId: string;
}

export interface AssociateCoachWithCoacheeParams {
	input: AssociateCoachWithCoacheeInput;
}

@Injectable({ providedIn: 'root' })
export class AssociateCoachWithCoacheeApiMutation extends ApiMutation<
	UserOutput,
	AssociateCoachWithCoacheeParams
> {
	client = 'iam';
	document = gql`
		mutation AssociateCoachWithCoachee($input: AssociateCoachWithCoacheeInput!) {
			associateCoachWithCoachee(input: $input) {
				...User
			}
		}
		${user}
	`;
	method = 'associateCoachWithCoachee';
}
